import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default function Footer() { 

return(

    <footer className="footer footer-center p-4 bg-base-300 text-base-content">
  <aside>
    <p>Amy Nguyen - Last Updated: March 2025</p>
  </aside>
</footer>


);
}